import { jsx as _jsx } from "react/jsx-runtime";
export function Text({ size = "md", tone = "default", as: Component = "p", className = "", children, ...rest }) {
    const toneClass = tone === "default" ? "" : ` nbs-text--${tone}`;
    return (_jsx(Component, { className: `nbs-text nbs-text--${size}${toneClass} ${className}`.trim(), ...rest, children: children }));
}
export function Heading({ level = 2, className = "", children, ...rest }) {
    const Tag = `h${level}`;
    return (_jsx(Tag, { className: `nbs-heading nbs-heading--${level} ${className}`.trim(), ...rest, children: children }));
}
//# sourceMappingURL=Typography.js.map